<template>
<div>
    <v-toolbar><v-btn @click="updateTokens()">Update Tokens</v-btn></v-toolbar>
    <organisations :organisations="organisations" :organisationtypes="organisationTypes" @organisationChange="getOrganisations()"></organisations>
</div>
  
</template>

<script>
import Api from "@/services/Api";
import Organisation from '@/components/Organisation.vue';

export default {
    
  components: {
    organisations: Organisation
  },
  data(){
      return{
          organisations: [],
          organisationTypes: []
      }
  },
  created(){
      this.initialize()
  },
  methods: {
      initialize(){
          this.getOrganisations();
          this.getOrganisationTypes();
      },
      updateTokens(){
          this.organisations.map(async a=>{
              await this.generateOrganisationToken(a)
          })
      },
      async generateOrganisationToken(item){
      await Api()
      .post('/orgToken',{
        id: item.id,
        name: item.name,
        description: item.description
      })
      .then(async response=>{
        await Api()
        .put('/organisation/'+item.id,{
          token: response.data.token
        })
      })
    },
      getOrganisations(){
          Api()
          .get('/Organisation')
          .then(response=>{
              this.organisations=response.data
          })
      },
      getOrganisationTypes(){
          Api()
          .get('/organisationType')
          .then(response=>{
              this.organisationTypes=response.data
          })
      }
  }
}
</script>

<style>

</style>